import {
  Flex,
  Icon,
  Box,
} from '@chakra-ui/react';
import {
  FiInfo,
} from 'react-icons/fi';

export default function InfoPane({ children, ...rest }) {
  return (
    <Flex
      align="flex-start"
      justify="flex-start"
      my={4}
      p={4}
      border="2px solid"
      borderColor="brand.blue.600"
      borderRadius="lg"
      backgroundColor="white"
      {...rest}
    >
      <Icon as={FiInfo} boxSize={6} color="brand.blue.600" />
      <Box pl={4}>
        {children}
      </Box>
    </Flex>
  );
}
